export function videoEvents(videos) {
	if (!videos.length) return;
	const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
	const firstEvent = isTouch ? "click" : "mouseenter";
	videos.forEach((video) => {
		async function onFirstInteraction(e) {
			video.removeEventListener(firstEvent, onFirstInteraction);
			const wistiaElem = video.querySelector(".wistia_embed");
			const wistiaId = wistiaElem?.dataset.ilawyerwistia;
			const youtubeId = video.dataset.ilawyeryoutube;
			try {
				if (wistiaId) {
					const { initWistia } = await import("./video-wistia.js");
					const playWistia = initWistia(video, wistiaId);
					if (e.type === "click") playWistia(e);
				}
				if (youtubeId) {
					const { initYoutube } = await import("./video-youtube.js");
					const handlePlayback = initYoutube(video, youtubeId);
					if (e.type === "click") handlePlayback(e);
				}
			} catch (err) {
				console.error("Video module load failed:", err);
			}
		}
		video.addEventListener(firstEvent, onFirstInteraction, { passive: true });
	});
}
